import { useContext, useEffect, useState } from "react";
import InputField from "../../components/InputField/InputField";
import { Link, useLocation } from "react-router-dom";
import { MetamaskInstructionContainer, styles } from "./styles";
import { ethers } from "ethers";
import { GenericProvider } from "../../global";
import { useNavigate } from "react-router-dom";
import { backOff } from "exponential-backoff";
import { useAuth0 } from "@auth0/auth0-react";
import { OmmuseClient } from "../../proto/api_grpc_web_pb";
import { RegisterUserWalletRequest } from "../../proto/api_pb";
import { Box } from "@mui/material";
import { UserDetailsContextInterface } from "../../contexts";
import { UserDetailsContext } from "../../contexts";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import Button from "@mui/material/Button";

const MetaMaskSetup: React.FC = () => {
  const [walletAddress, setWalletAddress] = useState<any>(undefined);
  const [errorWalletAddress, setErrorWalletAddress] = useState(false);
  const { getIdTokenClaims } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const { getValidAccessToken } = useGetValidAccessToken();
  const { connectedWallet } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const data: string = event.target.value;
    console.log(data);
  };
  const handleSubmit = async () => {
    const accessToken = await getValidAccessToken();
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new RegisterUserWalletRequest();
    console.log(location.state);
    let userId;
    if (location.state === null) {
      const idToken = await getIdTokenClaims();
      if (idToken) {
        userId = idToken.sub;
      }
    } else {
      userId = location.state.userId;
    }
    request.setUserId(userId);
    request.setWalletAddress(walletAddress);
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };
    await backOff(
      () =>
        new Promise((resolve, reject) => {
          ommuseClient.registerUserWallet(
            request,
            metadata,
            function (err, response) {
              if (err) {
                console.log("register user wallet error");
                console.log(err.message);
                reject(err);
              } else {
                console.log("resgistered user wallet successfully");
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
    navigate("/");
  };

  useEffect(() => {
    if (window.ethereum && !connectedWallet) {
      const provider = new ethers.providers.Web3Provider(window.ethereum!);
      provider.getSigner();
      if (provider) {
        if (!walletAddress) {
          provider.send("eth_requestAccounts", []).then((res) => {
            if (res && Array.isArray(res)) {
              setWalletAddress(res[0]);
            }
          });
        }
        (window.ethereum as GenericProvider).on(
          "accountsChanged",
          (accounts) => {
            console.log("account changed....");
            if (accounts && Array.isArray(accounts)) {
              setWalletAddress(accounts.length === 0 ? undefined : accounts[0]);
              setErrorWalletAddress(false);
            }
          }
        );
      }
    }
  }, [walletAddress, connectedWallet]);

  return (
    <div style={styles.container} className="row-one">
      <InputField
        label="wallet"
        error={errorWalletAddress && true}
        value={connectedWallet || walletAddress || "Wallet Address"}
        onchange={handleChange}
        type="text"
        disabled={Boolean(walletAddress)}
        metamask
      />
      <Button
        onClick={handleSubmit}
        sx={styles.button}
        size="large"
        variant="contained"
        disabled={Boolean(!connectedWallet) && Boolean(!walletAddress)}
      >
        Continue
      </Button>
      {!walletAddress ? (
        <>
          <MetamaskInstructionContainer>
            <p>
              If you have already installed Metamask please login and select a
              wallet. You will see the address above and then click continue. If
              you have not installed Metamask click below.
              <br />
            </p>
          </MetamaskInstructionContainer>
          <Box sx={styles.buttonContainer}>
            <Link
              target="_blank"
              to="https://metamask.io/download"
              style={{ textDecoration: "none" }}
            >
              <Button style={styles.downloadSkipButton} variant="contained">
                Download Metamask
              </Button>
            </Link>

            <p>Please refresh this page after you login to Metamask</p>
          </Box>
        </>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default MetaMaskSetup;
